module.exports = __webpack_public_path__ + "static/img/bg-career-detail.13cc258a.jpg";